/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ECWResultMessage = {
    readonly id?: number;
    status?: ECWResultMessage.status;
    /**
     * Optional reason for error status
     */
    error_reason?: string | null;
    readonly created_at?: string;
}

export namespace ECWResultMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
